import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import './styles/global.css';

// Pages
import HomePage from './pages/HomePage';
import { LoginPage, SignupPage } from './pages/AuthPages';
import ERPLayout from './components/ERPLayout';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import Attendance from './pages/Attendance';
import { Fees, Holidays, Notices, WhatsApp } from './pages/FeesHolidaysNotices';
import { Teachers, Exams, Library, Reports, Settings } from './pages/OtherPages';
import { Classes, Timetable } from './pages/ClassesTimetable';
import StudentPortal from './pages/StudentPortal';

// Protected route - requires admin or teacher
const ERPRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!['admin', 'teacher'].includes(user.role)) {
    return <div style={{ padding: 40, fontFamily: 'Poppins', textAlign: 'center' }}>
      <h2>Access Denied</h2>
      <p>ERP access is restricted to admin and teachers only.</p>
      <p style={{ marginTop: 12, color: '#6b7280', fontSize: '0.875rem' }}>Contact your administrator to get the correct role assigned.</p>
    </div>;
  }
  return children;
};

// Auth route - redirect if logged in
const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  if (user && ['admin', 'teacher'].includes(user.role)) return <Navigate to="/erp" replace />;
  return children;
};

// Portal route - for students/parents
const PortalRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public website */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/signup" element={<PublicRoute><SignupPage /></PublicRoute>} />

      {/* ERP (Admin + Teacher only) */}
      <Route path="/erp" element={<ERPRoute><ERPLayout /></ERPRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="students" element={<Students />} />
        <Route path="teachers" element={<Teachers />} />
        <Route path="classes" element={<Classes />} />
        <Route path="timetable" element={<Timetable />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="exams" element={<Exams />} />
        <Route path="fees" element={<Fees />} />
        <Route path="library" element={<Library />} />
        <Route path="notices" element={<Notices />} />
        <Route path="holidays" element={<Holidays />} />
        <Route path="whatsapp" element={<WhatsApp />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* Student/Parent Portal */}
      <Route path="/portal" element={<PortalRoute><StudentPortal /></PortalRoute>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
        <Toaster
          position="top-right"
          toastOptions={{
            style: { fontFamily: 'Poppins', fontWeight: 600, fontSize: '0.875rem', borderRadius: 10 },
            success: { style: { background: '#e6f4ea', color: '#0f9d58', border: '1px solid #b7dfca' } },
            error: { style: { background: '#fce8e6', color: '#d93025', border: '1px solid #f5c6c3' } },
          }}
        />
      </AuthProvider>
    </Router>
  );
}
